import * as React from 'react';
import { IFullscreenSlide } from '../../../types/gallery';
import { IMediaItem } from '../../../types/newbuilding/constructionProgress';
import { Image } from '../Image';

const slideErrorImg = require('../slide_error.svg');
const thumbErrorImg = require('../thumb_error.svg');

const slideError = { text: 'Ошибка загрузки :(', img: slideErrorImg };
const thumbError = { img: thumbErrorImg };

export function prepareSlides(mediaData: IMediaItem[]): IFullscreenSlide[] {
  return mediaData.map(media => ({
    node: <Image src={media.fullUrl} error={slideError} spinnerSize={32} />,
    thumbnailNode: <Image src={media.thumbnailUrl} fit="cover" error={thumbError} spinnerSize={16} />,
  }));
}
